import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, of, map, take, catchError } from 'rxjs';

import { MaintenanceConfigResponse, MaintenanceConfigFeature } from '../../interfaces/maintenance-config.interface';
import { MonitoringLogger } from '../monitoring/monitoring-logger';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceConfigService {
  private http = inject(HttpClient);
  private configService = inject(ConfigService);
  private monitoringLogger = inject(MonitoringLogger);

  /**
   * Fetches response from maintenance config endpoint
   */
  getMaintenanceConfig(): Observable<MaintenanceConfigResponse> {
    return this.http.get<MaintenanceConfigResponse>(`${this.configService.cfg.configUrl}/config`).pipe(
      catchError((err: unknown) => {
        this.monitoringLogger.error('Failed to fetch config for features under maintenance break', { error: err });
        return of({});
      })
    );
  }

  /**
   * Returns boolean value for the feature to check the disabled status
   * @param key feature to get from config response
   */
  getStatusForFeature(key: MaintenanceConfigFeature): Observable<boolean> {
    return this.getMaintenanceConfig().pipe(
      take(1),
      map((config) => {
        // fallback to false when fetched feature is not in response
        // or if value for it is not boolean as expected
        if (!config[key] || typeof config[key] !== 'boolean') {
          return false;
        }

        return config[key];
      })
    );
  }
}
